import { render, staticRenderFns } from "./CopyQuotation.vue?vue&type=template&id=63164f2e&"
import script from "./CopyQuotation.vue?vue&type=script&lang=js&"
export * from "./CopyQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports